module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/heWaL/tc-custom/9781625857583.jpg?1702530060367",
      "alt": "This image is the cover for the book Crowley's, Landmarks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Crowley's, Landmarks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Operating in the shadow of the enormous J.L. Hudson Co., Crowley's earned Detroit's trade with fine merchandise and good service, all in an atmosphere that made it the Motor City's \"friendly\" department store. Generations of customers still hold Crowley's close in their memories, fondly recalling the store's ancient wooden escalators, fashionable merchandise and special events like \"Breakfast with Santa.\" Wander back in time with historian Bruce Allen Kopytek through the venerable old store and its suburban branches to discover all the things that made Crowley's such a special retail destination.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bruce Allen Kopytek\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Bruce Allen Kopytek is the author of Eaton's, Toledo's 3 L's and Jacobson's, I Miss It So! Raised in Detroit, he runs the popular Department Store Museum website.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0